import { useAuthStore } from '@/core/auth/auth-store'
import { useCurrentClubStore } from '@/core/auth/current-club-store'

/** Orientation belongs to this operator in this club, never to a shared tablet.
 * Legacy unscoped keys deliberately do not migrate: their owner is unknown. */
export function makeOrientationAck(step: string) {
  const key = () => {
    const uid = useAuthStore.getState().user?.uid
    const clubId = useCurrentClubStore.getState().clubId
    return uid && clubId ? `cm.orientation.v2:${JSON.stringify([uid, clubId, step])}` : null
  }
  return {
    is: (): boolean => {
      try { const scoped = key(); return scoped !== null && localStorage.getItem(scoped) === '1' }
      catch { return false }
    },
    mark: (): void => {
      try { const scoped = key(); if (scoped) localStorage.setItem(scoped, '1') }
      catch { /* Storage is optional; leave the orientation visible. */ }
    },
  }
}
